import React, { lazy } from "react";
import PrivateAuth from "./PrivateAuth";
import CategoryList from "../Views/Main Panel/CategoryDetails/CategoryList";
import AddCategory from "../Views/Main Panel/CategoryDetails/AddCategory";
import OrderDetails from "../Views/Main Panel/OrderDetail/OrderList";
import RestroList from "../Views/Main Panel/RestroList/RestroList";
import AllRestroList from "../Views/Main Panel/AllRestroList/AllRestroList";
import Profile from "../Views/Profile/Profile";
import TransactionList from "../Views/Main Panel/TransactionList/transactionList";
import Permissions from "../Views/Main Panel/Role-Permissions/Permissions";
import Brand from "../Views/Main Panel/BrandingManagment/Brand";
import { BiFoodMenu } from "react-icons/bi";
import MenuList from "../Views/Main Panel/MenuList/MenuList";

// Import Plans Components
import Plans from "../Views/Main Panel/Plans";
import CreatePlan from "../Views/Main Panel/Plans/CreatePlan";
import EditPlan from "../Views/Main Panel/Plans/EditPlan";
import AssignPlan from "../Views/Main Panel/Plans/AssignPlan";

// const ShowProperties = lazy(() =>
//   import("../Views/Main Panel/Properties/ShowProperties")
// );
// const Requests = lazy(() => import("../Views/Main Panel/Requests"));
// const Shops = lazy(() => import("../Views/Main Panel/Reports/Shops"));
const Dashboard = lazy(() => import("../Views/Main Panel/Dashboard"));

// const AmenitiesDetails = lazy(() => import("../Views/Main Panel/Amenities"));
// const CategoryDetails = lazy(() =>
//   import("../Views/Main Panel/CategoryDetails")
// );
const VendorsDetails = lazy(() => import("../Views/Main Panel/VendorsDetails"));

const privateAdminRoute = () => {
  return [
    {
      element: <PrivateAuth />,
      children: [
        {
          path: "/dashboard",
          element: <Dashboard />,
          title: "Dashboard",
        },
        {
          path: "/vendorsDetails",
          element: <VendorsDetails />,
          title: "Vendors",
        },
        {
          path: "/menu",
          element: <MenuList />,
          title: "FoodMenu",
        },
        {
          path: "/categoryList",
          element: <CategoryList />,
          title: "Vendors",
        },
        {
          path: "/addcategory",
          element: <AddCategory />,
          title: "Vendors",
        },
        {
          path: "/orderlist",
          element: <OrderDetails />,
          title: "Vendors",
        },
        {
          path: "/restrolist/:id",
          element: <RestroList />,
          title: "Vendor Restaurants",
        },
        {
          path: "/restrolist",
          element: <AllRestroList />,
          title: "Vendors",
        },
        {
          path: "/transactionList",
          element: <TransactionList />,
          title: "Vendors",
        },
        {
          path: "/permissionList",
          element: <Permissions />,
          title: "Role Management",
        },
        {
          path: "/brandList",
          element: <Brand />,
          title: "Brand Management",
        },
        {
          path: "/profile",
          element: <Profile />,
          title: "profile",
        },
        // ============ ✅ NEW PLAN ROUTES ============
        {
          path: "/plans",
          element: <Plans />,
          title: "Plan Management",
        },
        {
          path: "/plans/create",
          element: <CreatePlan />,
          title: "Create Plan",
        },
        {
          path: "/plans/edit/:id",
          element: <EditPlan />,
          title: "Edit Plan",
        },
        {
          path: "/plans/assign",
          element: <AssignPlan />,
          title: "Assign Plan",
        },
        // ============================================

        // {
        //   path: "/amenitiesDetails",
        //   element: <AmenitiesDetails />,
        // },
        // {
        //   path: "/categoryDetails",
        //   element: <CategoryDetails />,
        // },
        // {
        //   path: "/showShops",
        //   element: <Shops />,
        // },
        // {
        //   path: "/userRequests",
        //   element: <Requests />,
        // },
        // {
        //   path: "/propertiesDetails",
        //   element: <Properties />,
        // },
        // {
        //   path: "/showDetails",
        //   element: <ShowProperties />,
        // },
        // {
        //   path: "/createProperty",
        //   element: <CreateProperty />,
        // },
        {
          path: "*",
          element: <Dashboard />,
        },
      ],
    },
  ];
};

export default privateAdminRoute;